import * as React from 'react'
import { cn } from '../../../utils'
import { Icon } from '../../icon'
import { IconButton } from '../../icon-button'
import { BaseField } from '../base-field/BaseField'
import { Input } from '../base-field/input'
import styles from './SearchField.module.css'
import { SearchFieldProps } from './SearchField.types'

function SearchField(props: SearchFieldProps) {
  const { defaultValue, name, onChange, onBlur, placeholder, autoFocus = false, ariaLabel, className, clearButtonAriaLabel, ...baseFieldProps } = props
  const [internalValue, setInternalValue] = React.useState<string>((defaultValue as string) || '')
  const inputRef = React.useRef<HTMLInputElement>(null)

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInternalValue(e.target.value)
    onChange?.(e)
  }

  const handleOnClear = () => {
    if (!inputRef?.current)
      return

    inputRef.current.value = ''
    setInternalValue('')

    onChange?.({ target: { value: '' } } as React.ChangeEvent<HTMLInputElement>)
  }

  React.useEffect(() => {
    if (autoFocus) {
      inputRef.current?.focus()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  React.useEffect(() => {
    if (inputRef.current) {
      setInternalValue(inputRef.current.value)
    }
  }, [inputRef?.current?.value])

  return (
    <BaseField {...baseFieldProps} className={cn(className)}>
      <Icon glyph="Magnifier" size={20} className={styles.iconWrapper} />
      <Input
        defaultValue={defaultValue}
        name={name}
        disabled={baseFieldProps.disabled}
        onChange={handleOnChange}
        onBlur={onBlur}
        placeholder={placeholder}
        ref={inputRef}
        aria-label={ariaLabel}
        className={styles.searchInput}
      />
      {internalValue.length > 0 && (
        <IconButton variant="secondary" glyph="DismissSmall" className={styles.clearButton} size="XS" onClick={handleOnClear} aria-label={clearButtonAriaLabel} />
      )}
    </BaseField>
  )
}

SearchField.displayName = 'SearchField'

export default SearchField
